<template>
  <v-app>
    <headbar />
    <router-view></router-view>
    <footbar />
  </v-app>
</template>

<script>
// import HelloWorld from "./components/HelloWorld";
// import director from "./components/director";
import headbar from "./components/headbar";
import footbar from "./components/footbar";

export default {
  name: "App",

  components: {
    headbar,
    footbar
  },

  data: () => ({
    //
  })
};
</script>

<style>
/* width */
::-webkit-scrollbar {
  width: 20px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px blue;
  border-radius: 10px;
  background: gold;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #0000b3;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #000080;
}
</style>
